import { styled } from 'styled-system/jsx'

const Wrapper = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    paddingY: '8px',
  },
})

const Heading = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    letterSpacing: '-0.5px',
    color: 'quickpass.ink',
    margin: '0',
  },
})

const Subtext = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.55',
    margin: '0',
  },
})

const ChoiceGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '14px',
    marginTop: '4px',
  },
})

const ChoiceTile = styled('button', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    textAlign: 'left',
    padding: '22px',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'lg',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-2px)',
      borderColor: 'quickpass.primary',
      boxShadow: '0 16px 40px -20px rgba(128, 84, 255, 0.4)',
    },
  },
})

const ChoiceIcon = styled('span', {
  base: {
    fontSize: '30px',
    lineHeight: '1',
  },
})

const ChoiceTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '19px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const ChoiceDescription = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.45',
  },
})

const SectionCard = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'lg',
  },
})

const SectionIntro = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.55',
    margin: '0',
  },
})

const ActionStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
})

const ActionButton = styled('button', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
    textAlign: 'left',
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '600',
    color: 'quickpass.ink',
    backgroundColor: 'quickpass.surfaceCool',
    border: 'none',
    borderRadius: 'sm',
    padding: '14px 16px',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, background {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateX(2px)',
      backgroundColor: '#EFEAFE',
    },
  },
})

const ActionArrow = styled('span', {
  base: {
    color: 'quickpass.primary',
    fontWeight: '800',
  },
})

const Form = styled('form', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const Label = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    letterSpacing: '0.2px',
  },
})

const CategoryRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
})

const CategoryChip = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'quickpass.surfaceCool',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'pill',
    padding: '8px 14px',
    cursor: 'pointer',
    transition:
      'background {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
    },
    '&[aria-pressed="true"]': {
      backgroundColor: 'quickpass.primary',
      borderColor: 'quickpass.primary',
      color: '#FFFFFF',
    },
  },
})

const MessageTextarea = styled('textarea', {
  base: {
    width: '100%',
    minHeight: '120px',
    resize: 'vertical',
    fontFamily: 'body',
    fontSize: '15px',
    lineHeight: '1.5',
    color: 'quickpass.ink',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'sm',
    padding: '12px 13px',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _focus: {
      outline: 'none',
      borderColor: 'quickpass.primary',
      boxShadow: '0 0 0 3px rgba(128, 84, 255, 0.18)',
    },
    _placeholder: {
      color: 'quickpass.inkSoft',
    },
  },
})

const SubmitButton = styled('button', {
  base: {
    alignSelf: 'flex-start',
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '700',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    borderRadius: 'pill',
    paddingX: '24px',
    paddingY: '12px',
    cursor: 'pointer',
    boxShadow: '0 8px 22px -8px rgba(128, 84, 255, 0.55)',
    transition:
      'transform {durations.fast} {easings.appleStandard}, opacity {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-1px)',
    },
    _disabled: {
      opacity: '0.55',
      cursor: 'not-allowed',
      transform: 'none',
    },
  },
})

const BackButton = styled('button', {
  base: {
    alignSelf: 'flex-start',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '4px 0',
    _hover: {
      color: 'quickpass.primary',
    },
  },
})

const SuccessIcon = styled('div', {
  base: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: 'quickpass.primary',
    color: '#FFFFFF',
    fontSize: '28px',
    fontWeight: '800',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

const ErrorBanner = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.warmth',
    padding: '10px 14px',
    borderRadius: 'sm',
  },
})

export {
  Wrapper,
  Heading,
  Subtext,
  ChoiceGrid,
  ChoiceTile,
  ChoiceIcon,
  ChoiceTitle,
  ChoiceDescription,
  SectionCard,
  SectionIntro,
  ActionStack,
  ActionButton,
  ActionArrow,
  Form,
  Label,
  CategoryRow,
  CategoryChip,
  MessageTextarea,
  SubmitButton,
  BackButton,
  SuccessIcon,
  ErrorBanner,
}
